import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import update from 'immutability-helper';
import jump from 'jump.js';
import { throttle } from 'lodash-es';
import { component } from 'picoapp';
import gsap from 'gsap';
import CartList from './CartList';

class MiniCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      cart: {},
    };
    this.toggle = this.toggle.bind(this);
    this.updateLineQuantity = this.updateLineQuantity.bind(this);
    this.updateOrderNotes = this.updateOrderNotes.bind(this);
  }

  componentDidMount() {
    const { parentNode } = this.props;
    this.container = parentNode;
    this.updateCartInfo();
    this.calculatePositioning();
    this.freeShippingMininum = "$" + (parseInt(parentNode.dataset.freeShipping) / 100);
    document.body.addEventListener('cart.productAdded', (ev) => {
      // console.log('Minicart received cart.productAdding event');
      this.updateCartInfo(ev);
    });

    // When minicart open and users clicks outside it, close the dialog
    document.addEventListener('click', (ev) => {
      const isClickInside = this.container.contains(event.target);
      if (!isClickInside && this.state.open) {
        this.close();
      }
    });

    this.container.addEventListener('focus', () => {
      this.open();
    });

    //window.addEventListener('resize', throttle(this.calculatePositioning, 600).bind(this));

    // Check if we have a logged in customer
    this.setState({
      customerName: parentNode.dataset.loggedIn,
    });
  }

  calculatePositioning() {
    if (this.tl) {
      this.destroyAnimations();
    }
    const coordinates = this.container.getBoundingClientRect();
    // console.log('Coordinates:', coordinates);
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    if (coordinates.x >= w / 2) {
      this.positioning = 'bottom center';
    } else {
      this.positioning = 'side right';
    }
    this.container.dataset.position = this.positioning;
    // console.log('MiniCart Positioning:', this.positioning);
    this.setupAnimations();
  }

  destroyAnimations() {
    const dropdown = this.container.querySelector('.MiniCart__dropdown');
    dropdown.style = '';
    this.tl.kill();
    this.tl = null;
  }

  setupAnimations() {
    const container = this.container;
    const dropdown = container.querySelector('.MiniCart__dropdown');
    const dropdownSections = container.querySelector('.MiniCart__contents');
    const buttonDeco = container.querySelector('.MiniCart__toggle .background');

    this.tl = new gsap.timeline({});
    this.tl.set(dropdown, { display: 'block', immediateRender: false });
    //this.tl.set(dropdownSections, { display: 'block', immediateRender: false });

    switch (this.positioning) {
      case 'side right':
        this.tl.from(dropdown, {
          // x: 100,
          opacity: 0,
          ease: 'Back.easeOut.config(1.7)',
          duration: 0.25,
        });
        /* this.tl.from(dropdownSections, {
          opacity: 0,
          ease: 'Back.easeOut.config(1.3)',
          duration: 0.3,
          stagger: 0.1
        }); */
        break;
      case 'bottom center':
        this.tl.from(dropdown, {
          opacity: 0,
          ease: 'Back.easeOut.config(1.7)',
          duration: 0.25,
        });
        /* this.tl.from(dropdownSections, {
          // y: '10%',
          opacity: 0,
          ease: 'Back.easeOut.config(1.3)',
          duration: 0.3,
          stagger: 0.1
        }); */
        break;

      default:
        break;
    }

    this.tl.pause();
  }

  toggle(ev) {
    ev.preventDefault();
    if (this.state.open) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.setState({ open: true }, () => {
      this.tl.play();
    });
    document.querySelector('body').style.overflowY = 'hidden';
  }

  close() {
    this.setState({ open: false }, () => {
      this.tl.reverse();
    });
    document.querySelector('body').style.overflowY = 'auto';
  }

  updateOrderNotes(e) {
    axios
      .post('/cart/update.js', {
        note: e.target.value,
      })
      .then((response) => {
        const newState = update(this.state.cart, {
          $set: response.data,
        });
        this.setState({ cart: newState });
        // console.log('Cart has updated with the data: ', newState);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateCartInfo(ev) {
    // Get Cart Info
    axios
      .get('/cart.js', { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        const newState = update(this.state.cart, {
          $set: response.data,
        });

        this.setState({ cart: newState }, () => {
          if (ev) {
            const minicartUpdated = new CustomEvent('cart.cartUpdated', {
              detail: response.data,
            });
            document.body.dispatchEvent(minicartUpdated);
            this.setState({ shouldOpenCart: true });
            this.open();
            jump(this.toggle, {
              duration: 600,
              offset: -200,
            });
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateLineQuantity(productVariantId, newQuantity) {
    axios
      .post('/cart/update.js', {
        updates: { [productVariantId]: newQuantity },
      })
      .then((response) => {
        const newState = update(this.state.cart, {
          $set: response.data,
        });
        this.setState({ cart: newState });
        // console.log('Cart has updated with the data: ', newState);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  renderUserAccountOptions() {
    if (this.state.customerName !== '') {
      return (
        <div className="Nav Nav--vertical">
          <div className="header">Hello, {this.state.customerName}!</div>
          <a href="/account" className="Nav__item">
            My Account
          </a>
          <a href="/account/logout" className="Nav__item" data-no-swup>
            Sign Out
          </a>
        </div>
      );
    } else {
      return (
        <div className="Nav Nav--vertical">
          <a href="/account/login" className="Nav__item">
            Sign In
          </a>
          <a href="/account/register" className="Nav__item">
            Create Account
          </a>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="MiniCartButton" tabIndex="0">
        <a href="/cart" className="Nav__item MiniCart__toggle" onClick={this.toggle}>
          <svg className="icon" width="1em" height="1em" viewBox="0 0 30 29">
            <g id="Design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="1-Homepage" transform="translate(-1680.000000, -27.000000)">
                <g id="Group-11">
                  <rect id="Rectangle-Copy" fill="#FFFFFF" x="0" y="0" width="1920" height="82"></rect>
                  <g id="ico_cart" transform="translate(1680.000000, 27.000000)" fill="#000000">
                    <g id="noun_cart_961145">
                      <g id="Group" fillRule="nonzero">
                        <path
                          d="M29.4656471,5.68930488 C29.2648235,5.44563415 28.9655294,5.30487805 28.6503529,5.30487805 L24.4884706,5.30487805 C23.9036471,5.30487805 23.4296471,5.77984146 23.4296471,6.36585366 C23.4296471,6.95186585 23.9036471,7.42682927 24.4884706,7.42682927 L27.3716471,7.42682927 L25.2935294,18.3902439 L11.8641176,18.3902439 L7.62247059,0.811646341 C7.50741176,0.335268293 7.08211765,0 6.59329412,0 L1.05882353,0 C0.474,0 0,0.474963415 0,1.06097561 C0,1.6469878 0.474,2.12195122 1.05882353,2.12195122 L5.75964706,2.12195122 L10.0016471,19.7005488 C10.1163529,20.1769268 10.5416471,20.5121951 11.0308235,20.5121951 L26.1705882,20.5121951 C26.6791765,20.5121951 27.1161176,20.1500488 27.2107059,19.6492683 L29.6904706,6.56390244 C29.7494118,6.25339024 29.6671765,5.93262195 29.4656471,5.68930488 Z"
                          id="Path"
                        ></path>
                        <path
                          d="M23.4296471,21.4699024 C21.4065882,21.4699024 19.7604706,23.1193659 19.7604706,25.1465366 C19.7604706,27.1737073 21.4062353,28.8231707 23.4296471,28.8231707 C25.4530588,28.8231707 27.0988235,27.174061 27.0988235,25.1465366 C27.0988235,23.1190122 25.4527059,21.4699024 23.4296471,21.4699024 Z M23.4296471,26.7012195 C22.5741176,26.7012195 21.8781176,26.0038049 21.8781176,25.1465366 C21.8781176,24.2892683 22.5741176,23.5918537 23.4296471,23.5918537 C24.2851765,23.5918537 24.9811765,24.289622 24.9811765,25.1465366 C24.9811765,26.0034512 24.2851765,26.7012195 23.4296471,26.7012195 Z"
                          id="Shape"
                        ></path>
                        <path
                          d="M13.6408235,21.4699024 C11.6177647,21.4699024 9.97164706,23.1193659 9.97164706,25.1465366 C9.97164706,27.1737073 11.6177647,28.8231707 13.6408235,28.8231707 C15.6638824,28.8231707 17.31,27.174061 17.31,25.1465366 C17.31,23.1190122 15.6642353,21.4699024 13.6408235,21.4699024 Z M13.6408235,26.7012195 C12.7852941,26.7012195 12.0892941,26.0038049 12.0892941,25.1465366 C12.0892941,24.2892683 12.7852941,23.5918537 13.6408235,23.5918537 C14.4963529,23.5918537 15.1923529,24.289622 15.1923529,25.1465366 C15.1923529,26.0034512 14.4963529,26.7012195 13.6408235,26.7012195 Z"
                          id="Shape"
                        ></path>
                        {this.state.cart && this.state.cart.item_count > 0 && <circle fill="#03ACCE" cx="18" cy="12" r="6" />}
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          {/* <div className="item_count">{this.state.cart ? this.state.cart.item_count : 0} item(s)</div> */}
          <span className="background" />
        </a>
        <div className="MiniCart__dropdown">
          <span className="arrow" />
          <div className="MiniCart__contents">
            <CartList
              cart={this.state.cart}
              products={this.state.cart.items}
              updateLineQuantity={this.updateLineQuantity}
              updateOrderNotes={this.updateOrderNotes}
              freeShippingMininum={this.freeShippingMininum}
            />
            {/* {this.renderUserAccountOptions()} */}
          </div>
          <button type="button" className="Button close" data-style="noStyle" onClick={() => this.close()}>
            {/* <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                <use xlinkHref="#icon-close" />
              </svg> */}
            &times;
          </button>
        </div>
      </div>
    );
  }
}

export default component((node, ctx) => {
  const element = <MiniCart appstate={ctx} parentNode={node} />;
  ReactDOM.render(element, node);

  // Unmount component on Pjax navigation
  return function () {
    try {
      ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
      console.error(e);
    }
  };
});
